import React, { Component } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import ToggleSwitch from './common/toggleSwitch';
import Table from './common/table';
import auth from '../services/authService';

const $ = require('jquery');
$.DataTable = require('datatables.net');

class BTradesTable extends Component {
  columns = [
    {
      path: 'user',
      label: 'By',
      //content: user => <Link to={`/users/${user._id}`}>{user.phoneNumber}</Link>
    },
    {
      path: 'amount',
      label: 'Bitcoin Amount',
      content: (btrade) => btrade.amount,
    },
    {
      path: 'wallet_type',
      label: 'Wallet Type',
      content: (btrade) => btrade.wallet_type.name,
    },
    {
      path: 'created_at',
      label: 'Trade Date',
      content: (btrade) =>
        moment(btrade.created_at).startOf('day').format('LL'),
    },
    {
      key: (btrade) => btrade._id,
      label: 'Completed?',
      content: (btrade) => (
        <ToggleSwitch
          switched={btrade.isCompleted}
          handleChange={() => this.props.onCompleteSwitch(btrade)}
        />
      ),
    },
    {
      key: (btrade) => `${btrade._id}-ap`,
      label: 'Approved?',
      content: (btrade) => (
        <ToggleSwitch
          switched={btrade.isApproved}
          handleChange={() => this.props.onApproveSwitch(btrade)}
        />
      ),
    },
    {
      key: (btrade) => `${btrade._id}-s`,
      label: 'Info',
      content: (btrade) => (
        <Link
          to={`/bitcoins/show/${btrade._id}`}
          className="btn btn-primary btn-sm"
        >
          View
        </Link>
      ),
    },
  ];

  deleteColumn = {
    key: 'delete',
    label: 'Delete',
    content: (btrade) => (
      <button
        onClick={() => this.props.onDelete(btrade)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    ),
  };

  editColumn = {
    key: 'edit',
    label: 'Edit',
    content: (btrade) => (
      <Link
        to={`/bitcoins/edit/${btrade._id}`}
        className="btn btn-custom btn-sm"
      >
        Edit
      </Link>
    ),
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    if (user && user.isAdmin) {
      //this.columns.push(this.editColumn);
      //this.columns.push(this.deleteColumn);
    }
  }

  componentDidMount() {
    $(document).ready(function () {
      $('#dataTable').DataTable();
    });
  }

  render() {
    const { btrades, message } = this.props;
    return <Table columns={this.columns} data={btrades} message={message} />;
  }
}

export default BTradesTable;
